/**
 * Full-screen loading (the sign-in check, the start screen choice). Drawn like
 * index.html's #loading-screen, in its light or dark colours (the
 * --app-splash-* variables declared there), so the splash and this screen
 * follow each other without a flash. It was dark navy in both themes, so a
 * light-mode start went light, navy, light.
 */
export default function LoadingScreen() {
  return (
    <div
      style={{
        background: 'var(--app-splash-bg, #f8fafc)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
      }}
    >
      <img
        src="/icons/DietechLogo.png"
        alt="Dietech"
        style={{ height: 180, marginBottom: 40, filter: 'var(--app-splash-logo-filter, none)' }}
        onError={(e) => {
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
      <div className="spinner" />
      <p style={{ color: 'var(--app-splash-text, #475569)', fontSize: 'var(--font-size-large)', letterSpacing: 2, margin: '0 0 8px 0' }}>
        Loading application...
      </p>
      <p style={{ color: 'var(--app-splash-muted, #94a3b8)', fontSize: 'var(--font-size-base)', letterSpacing: 1, margin: 0 }}>
        V2.0
      </p>
    </div>
  );
}
